import React, { ButtonHTMLAttributes } from 'react';
import { ReactSVG } from 'react-svg';
import classNames from 'classnames';

import UISpinner from './UISpinner';

import Cancel from 'Assets/images/icons/cancel.svg';

interface UICancelButtonProps {
  onClick: () => Promise<void> | void;
  type?: ButtonHTMLAttributes<HTMLButtonElement>['type'];
  disabled?: boolean;
  isLoading?: boolean;
}

const UICancelButton = ({
  onClick,
  type = 'button',
  disabled = false,
  isLoading = false,
}: UICancelButtonProps) => {
  return (
    <button
      type={type}
      disabled={disabled}
      className={classNames('button', 'cancel', {
        'upload--disabled': disabled,
      })}
      onClick={onClick}
    >
      {isLoading ? (
        <UISpinner wrapperClassName="spinner__wrapper spinner__wrapper--overlay spinner__wrapper--full-cover spinner__wrapper--rounded" />
      ) : (
        <ReactSVG src={Cancel} className="documentHeaderButton__icon" />
      )}
    </button>
  );
};

export default UICancelButton;
